import React, { useReducer, useEffect } from "react";
import useSWR from "swr";

import { JsonLdTags } from "../../components/JsonLd";
import HeaderContent from "./HeaderContent";
import "./Header.scss";

export const reducer = (state, action) => {
  switch (action.type) {
    case "LOADED_DATA": {
      const settings = {
        ratingLimit: parseFloat((action.settings && action.settings.ratingLimit) || "4.0"),
      };
      const { averageRating } = action.payload;
      const showSchema = (averageRating >= settings.ratingLimit);

      return {
        merchant: action.payload,
        error: false,
        showSchema
      };
    }
    case "DATA_ERROR":
      return { merchant: null, error: true, showSchema: false };
    default:
      return state;
  }
};

export const defaultState = {
  merchant: null,
  error: false,
  showSchema: false
};
export const HeaderContext = React.createContext(defaultState);

const Header = (props) => {
  const fetcher = (...args) => fetch(...args).then((r) => r.json());
  const { data } = useSWR(
    `${process.env.REACT_APP_API_HOST}/api/public/v2/merchants/${props.merchant}.json?widget=header`,
    fetcher,
    { revalidateOnFocus: false }
  );

  const [state, dispatch] = useReducer(reducer, defaultState);

  useEffect(() => {
    if (data && data.merchant) {
      dispatch({
        type: "LOADED_DATA",
        payload: data.merchant,
        settings: props
      });
    }
  }, [data, props]);

  if (!data || !data.merchant) {
    return null;
  }

  return (
    <HeaderContext.Provider value={{ state, dispatch }}>
      {state.showSchema && <JsonLdTags merchant={data.merchant} reviews={[]} />}
      <HeaderContent
        merchant={data.merchant}
        props={props}
      />
    </HeaderContext.Provider>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/containers/Header/index.jsx